import React, { useEffect, useState } from "react";
import Navbar from "./navbar/Navbar";
import Footer from "./footer/footer";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Logo from "./donate.png";
import { useFlutterwave } from "react-flutterwave";
import Button from "@material-ui/core/Button";
import logo from "./navbar/images/Logo_image.png";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "40ch",
    },
  },
}));

function Donation() {
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [details, setDetails] = useState({
    amount: "",
    email: "",
    name: "",
  });

  function HandleChange(e) {
    e.preventDefault();
    const { name, value } = e.target;
    setDetails((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  }

  const config = {
    public_key: "FLWPUBK-f39639081d87da1131fe61c633c02662-X",
    tx_ref: Date.now(),
    amount: details.amount,
    currency: "ZMW",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      email: details.email,
      name: details.name,
    },
    customizations: {
      title: "The Fidel Foundation",
      description: "Donations made to the Fidel Foundation.",
      logo: logo,
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  return (
    <div>
      <Navbar />
      <div style={{ marginTop: "60px", textAlign: "center" }}>
        <img className="donate_img" src={Logo} alt="" />
        <h1 className="donation_p">
          Thank You, for Donating to our Foundation.
        </h1>
        <form className={classes.root} noValidate onSubmit={HandleChange}>
          <div className="input_fields">
          <div>
            <TextField
              name="name"
              id="outlined-search"
              label="Name"
              type="email"
              variant="outlined"
              autoComplete="false"
              onChange={HandleChange}
            />
            </div>
            <div>
            <TextField
              name="email"
              id="outlined-search"
              label="email"
              type="email"
              variant="outlined"
              autoComplete="false"
              onChange={HandleChange}
            />
            </div>
            <div>
            <TextField
              name="amount"
              id="outlined-password-input"
              label="Amount in ZMW"
              type="number"
              min="1"
              variant="outlined"
              autoComplete="false"
              onChange={HandleChange}
            />
            </div>
          </div>
          <Button
              className="Donate_btn"
              variant="contained"
              color="primary"
              onClick={() => {
                handleFlutterPayment({
                  callback: (response) => {
                    console.log(response);
                  },
                  onClose: () => {},
                });
              }}
            >
              DONATE NOW
            </Button>
        </form>
      </div>
      <Footer />
    </div>
  );
}

export default Donation;
